import { Component, OnInit, ViewChild, TemplateRef, ElementRef, Pipe, ChangeDetectorRef, Renderer2, ChangeDetectionStrategy, OnDestroy, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { Select2OptionData } from 'ng2-select2';
import { Select2TemplateFunction } from 'ng2-select2';
import { ApidataService } from 'src/app/services/apidata.service';
import { Router } from '@angular/router';
import { TransactionReq, ROfferReq } from 'src/app/enums/apiRequest';
import { SessionVar, RespCode, OpTypes } from 'src/app/enums/emums';
import { AuthService } from 'src/app/services/auth.service';
import { ApiService } from 'src/app/services/apiservices.service';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject, observable, Observable, of, Subject } from 'rxjs';
import { finalize, map, startWith, takeUntil } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'aditya-dth',
  templateUrl: './dth.component.html',
  styleUrls: ['./dth.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
// @Pipe({
//   name: 'safe'
// })
export class DthComponent implements OnInit, OnDestroy {
  @ViewChild('tabList') tabList!: ElementRef<HTMLUListElement>;
  @ViewChild('wrapperNav') wrapperNav!: ElementRef<HTMLDivElement>;
  scrollBarWidths = 40;
  activeIndex = 0;

  RechargeForm: FormGroup;
  mobile: any;
  amount: number;
  MobileplaceHolder = 'Select DTH Operator';
  AccountRemark = '';
  odata: any;
  public operator = 0;
  public OperatorData: Array<Select2OptionData>;
  public OperatorOptions: Select2Options;
  public filteredOperator: Observable<Array<Select2OptionData>>;
  IsRechargeSubmitted = false;
  DthInfoLoaded = false;
  DthInfoDataLoaded = false;
  CustInfoLoaded = false;
  CustInfoDataLoaded = false;
  DthInfo: any;
  CustInfo: any;
  IsbannerShow = true;
  CustInfoLoader = false;
  DTHInfoLoader = false;
  IsCustMore = false;
  spnMobile = '';
  cusValMobile = '';
  spnAmount = '';
  apiError: string = '';
  // slides = [
  //   {img: "../../../../assets/img/cus-img/dth-1.jpg"},
  //   {img: "../../../../assets/img/cus-img/dth-2.jpg"}

  // ];
  slides = [];
  slideConfig = { "slidesToShow": 1, "slidesToScroll": 1, autoplay: true, autoplaySpeed: 2000, arrows: true };
  IsDTHInfoCall = false;
  simplePlan = [];
  isMobile: any = false;
  _ngUnsubscribe$ = new Subject<string>();
  constructor(private apiData: ApidataService, private router: Router, private authService: AuthService, private apiService: ApiService,
    private loaderService: LoaderService,
    private fb: FormBuilder, private FormValidation: FormValidationService, private cdr: ChangeDetectorRef, private renderer: Renderer2, private el: ElementRef, protected _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.loaderService.show();
    const myDiv = this.el.nativeElement.querySelector('#myDiv');
    this.apiData.isMobileScreen$.subscribe((value) => {
      this.isMobile = value;
      if (value === true) {
        this.renderer.setStyle(myDiv, 'display', 'none');
        this.updateView()
      } else {
        this.renderer.removeStyle(myDiv, 'display');
        this.updateView()
      }
    })
    this.apiData.isMenuChange$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((value) => {
      if (value === true) {
        this.isMobile = value
        this.renderer.removeStyle(myDiv, 'display');
      }
    })

    if (localStorage.getItem('isMobile') === 'true') {
      // setTimeout(() => { 
      this.renderer.setStyle(myDiv, 'display', 'none');
      // },50)
    } else {
      this.renderer.removeStyle(myDiv, 'display');
    }
    this.OperatorOptions = {
      multiple: false,
      closeOnSelect: true,

      templateResult: this.templateResult,
      templateSelection: this.templateSelection
    };
    this.RechargeForm = this.fb.group({
      mobile: this.fb.control('', [Validators.required]),
      amount: this.fb.control('', [Validators.required]),
      // myControl: this.fb.control('')
      myControl: this.fb.control({ text: 'Select Operator' }), // placeholder value
    })
    /*  console.log(this.apiData.getSessionData(SessionVar.BaseData))*/
    this.OperatorData = this.apiData.getOperator(this.apiData.getRouteID(this.router.url.replace('/', '').replace('.html', '')));
    this.checIsLookupForAPI();
    this.GetB2CBanner();
    this.filteredOperator = this.RechargeForm.controls['myControl'].valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterOperator(value))
      );

    this.apiService.GetNumberList().subscribe(resp => {
      if (resp && resp.statuscode == RespCode.Success) {
        this.apiData.setSessionData(SessionVar.BaseData, resp.data);
        localStorage.setItem(SessionVar.BaseData, JSON.stringify(resp.data))

        this.OperatorData = this.apiData.getOperator(this.apiData.getRouteID(this.router.url.replace('/', '').replace('.html', '')));

        this.filteredOperator = this.RechargeForm.controls['myControl'].valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterOperator(value))
          );
      }
      this.loaderService.hide();
    });
  }

  private _filterOperator(object: any): Array<Select2OptionData> {
    let value = typeof (object) === 'object' ? object.text : object;
    if (value != null && value != "") {
      var filterValue = value.toLowerCase();
      var data = this.OperatorData.length > 0
        ? this.OperatorData.filter(operator => operator.text.toLowerCase().includes(filterValue))
        : [];
      return data;
    }
    else
      return this.OperatorData;
  }
  get r() { return this.RechargeForm.controls }
  public templateResult: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
    if (!state.id) {
      return state.text;
    }

    let image = '<span class="dropdown-img"></span>';

    if (state.additional.image) {
      image = '<span class="dropdown-img" ><img  src="' + state.additional.image + '"</span>';
    }

    return jQuery('<span></b> ' + image + ' <span>' + state.text + '</span></span>');
  }

  // function for selection template
  public templateSelection: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
    if (!state.id) {
      return state.text;
    }

    // return jQuery('<span> ' + state.text + '</span>');
    let image = '<span class="dropdown-img"></span>';

    if (state.additional.image) {
      image = '<span class="dropdown-img" ><img  src="' + state.additional.image + '"</span>';
    }

    return jQuery('<span class="search-ddl"></b> ' + image + ' <span>' + state.text + '</span></span>');
  }
  public Operatorchanged(e: any): void {

    this.operator = e.value;
    if (this.operator == 0) {
      this.MobileplaceHolder = 'Select DTH Operator';
      return;
    }

    this.odata = this.apiData.getOperatorData(this.operator);
    this.MobileplaceHolder = this.odata.accountName;
    this.AccountRemark = this.odata.accountRemak;
    if (this.odata.isAccountNumeric)
      this.RechargeForm.controls['mobile'].setValidators([Validators.minLength(this.odata.length),
      Validators.maxLength(this.odata.lengthMax), Validators.pattern('\\d{10}')]);
    else
      this.RechargeForm.controls['mobile'].setValidators([Validators.minLength(this.odata.length),
      Validators.maxLength(this.odata.lengthMax)]);
    this.RechargeForm.controls['amount'].setValidators([Validators.min(this.odata.min), Validators.max(this.odata.max),]);
    // Validators.pattern('^[0-9]+(\.?[0-9]?)')
    this.IsRechargeSubmitted = false;
    //

  }


  dthInfo() {
    // debugger;
    //if(!this.mobile || (this.mobile.toString().length<this.odata.length||this.mobile.toString().length>this.odata.lengthMax))
    //{
    //  this.DthInfoLoaded=false;
    //  this.DthInfo='';
    //  this.IsbannerShow=true;
    //  return
    //}
    var dthInfoReq: ROfferReq = {
      accountNo: this.mobile,
      oid: this.operator
    }
    this.DthInfo = [];
    this.DthInfoLoaded = false;

    this.DthInfoDataLoaded = true;
    if (localStorage.getItem(SessionVar.DthInfo + this.mobile)) {
      this.DthInfo = JSON.parse(localStorage.getItem(SessionVar.DthInfo + this.mobile));
      this.DthInfoLoaded = true;
      this.DthInfoDataLoaded = true;
    }
    else {
      this.DTHInfoLoader = true;
      this.apiData.LoaderToggle();
      this.apiService.DTHSimplePlanInfo(dthInfoReq)
        .pipe(
          finalize(() => {
            this.apiData.LoaderToggle();
            this.DTHInfoLoader = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe(resp => {

          this.apiData.LoaderToggle();
          this.DTHInfoLoader = false;
          if (resp && resp.statuscode == RespCode.Success) {
            if (resp.data) {


              this.DthInfo = resp.dataRP;
              // this.simplePlan = [];
              this.simplePlan = resp.data;
              // this.simplePlan.push({ "data": resp.data.find(el => el.pType == 'Broadcaster'), name: 'Broadcaster' });
              // this.simplePlan.push({ "data": resp.data.records["Add-On Pack"], name: 'Add-On Pack' });
              // this.simplePlan.push({ "data": resp.data.records["plan"], name: 'Plan' });
              // this.simplePlan.push({ "data": resp.data.records["Add-On Pack"], name: 'Add-On Pack' });

              this.CustInfoLoaded = false;

              this.DthInfoLoaded = true;
              this.IsbannerShow = false;
              setTimeout(() => {
                this.reAdjust();
              }, 100);
            } else {
              this.DthInfoDataLoaded = false;
            }
            this.DthInfoLoaded = true;
          }
        })
    }

  }

  dthSimplePlanInfo() {
    // debugger;
    if (!this.mobile || (this.mobile.toString().length < this.odata.length || this.mobile.toString().length > this.odata.lengthMax)) {
      this.CustInfoLoaded = false;
      // this.DthInfo='';
      this.CustInfo = '';
      //this.IsbannerShow=true;
      return
    }

    var dthInfoReq: ROfferReq = {
      accountNo: this.mobile,
      oid: this.operator
    }
    this.CustInfoLoader = true;
    this.apiData.LoaderToggle();
    this.apiService.DTHCustomerInfo(dthInfoReq).subscribe(resp => {
      //console.log(resp);
      this.apiData.LoaderToggle();
      this.CustInfoLoader = false;
      if (resp.dthciData && (resp.dthciData.statusCode == RespCode.Success || resp.dthciData.statuscode == RespCode.Success)) {
        if (resp.dthciData.data) {

          // if (resp.data.records) {
          //   this.DthInfo = resp.data.records
          //   this.CustInfo = this.DthInfo[0];
          // }
          // else {
          //   this.CustInfoDataLoaded = false;
          // }
          this.DthInfo = resp.dthciData.data;
          this.CustInfo = resp.dthciData.data;
          this.CustInfoLoaded = true;
          this.apiError = '';
        }
      } else {
        this.apiError = resp.msg || 'Something went wrong!';
      }
      this.cdr.detectChanges();
    })

    this.dthInfo();
  }
  proceedToAction() {

    this.IsRechargeSubmitted = true;


    if (this.FormValidation.CheckFormValidStatus(this.RechargeForm)) {
      if (this.FormValidation.checkControlValidation("mobile")) {
        if (this.FormValidation.RequiredValidation("mobile")) {
          this.spnMobile = this.MobileplaceHolder + " required";
        }
        else if (this.FormValidation.checkLength("mobile")) {
          this.spnMobile = this.odata.accountRemak;
        }
        else if (this.FormValidation.checkPattern("mobile") && this.odata.isAccountNumeric) {
          this.spnMobile = "Invalid subscriber Id or mobile no.";
        } else {
          this.spnMobile = "";
        }
      } else {
        this.spnMobile = "";
      }
      if (this.FormValidation.checkControlValidation("amount")) {
        if (this.FormValidation.RequiredValidation("amount")) {
          this.spnAmount = "Amount is required";
        }
        else if (this.FormValidation.checkMinMaxAmount("amount")) {
          this.spnAmount = "Amount should be between " + this.odata.min + " to " + this.odata.max;
        }
        else if (this.FormValidation.checkPattern("amount")) {
          this.spnAmount = "Invalid amount";
        }
      }
      // if (this.odata && this.mobile) {
      //   if (this.odata.length > this.mobile.toString().length) {
      //     this.spnMobile = this.odata.accountRemak;
      //   }
      // }
      if (this.odata) {
        if (!this.mobile) {
          this.cusValMobile = this.MobileplaceHolder + " required";
          this.cdr.detectChanges();
          return;
        } else if (this.mobile.length > this.odata.lengthMax || this.mobile.length < this.odata.length) {
          this.cusValMobile = this.MobileplaceHolder + ", Invalid length";
          this.cdr.detectChanges();
          return;
        } else {
          this.cusValMobile = "";
        }
      } else {
        this.cusValMobile = "";
      }
      this.cdr.detectChanges();
      return;
    }
    if (!this.mobile) {

      this.spnMobile = this.MobileplaceHolder + " required";
      return;
    }
    if (!this.amount) {
      this.spnAmount = "Amount is required";

      return;
    }
    if (this.operator == 0) {
      return;
    }
    var transactionReq: TransactionReq = {
      accountNo: this.mobile,
      amount: this.amount,
      customerNo: '',
      geoCode: '',
      o1: '',
      o2: '',
      o3: '',
      o4: '',
      oid: this.operator,
      refID: ''
    }
    this.apiData.setSessionData(SessionVar.TransactionRequest, transactionReq);
    if (this.authService.IsAuth()) {
      this.apiData.loadOtherClass();
      this.router.navigate(['redirecttoaction.html'], { queryParams: { reff: '3309a24d426f5ee0d77b91f885ee641b', aid: '538536ff5636f4dc4e894b16182a3165b8413ac0cbabf91126fe2b8be4795f86d3a59a416a6b7b8920d00b0af0109b50' } })
    }
    else {
      this.apiData.loadOtherClass();
      this.router.navigate(['login.html'], { queryParams: { reff: '3309a24d426f5ee0d77b91f885ee641b', pid: '538536ff5636f4dc4e894b16182a3165b8413ac0cbabf91126fe2b8be4795f86d3a59a416a6b7b8920d00b0af0109b50' } });

    }
  }
  checIsLookupForAPI() {
    var req = { mobile: "", userID: "" }
    this.apiService.CheckIsLookUpFromAPI(req).subscribe(resp => {
      if (resp) {
        this.IsDTHInfoCall = resp.isDTHInfoCall;
      }
    })
  }
  GetB2CBanner() {
    const url = this.router.url.replace('/', '').replace('.html', '');
    const serviceId = this.apiData.getRouteID(url);
    var req = { opType: serviceId };
    this.apiService.GetB2CBanner(req).subscribe(resp => {
      if (resp && resp.bannerUrl) {
        this.slides = resp.bannerUrl;
        // this.cdr.detectChanges()
        this.updateView()
      }
    })
  }
  GetDTHPlans() {
    if (this.mobile) {
      if (this.IsDTHInfoCall && (this.mobile.toString().length >= this.odata.length && this.mobile.toString().length <= this.odata.lengthMax)) {
        this.dthSimplePlanInfo();
      }
    }
    else {
      this.DthInfoLoaded = false;
      this.CustInfoLoaded = false;
      //this.DthInfo='';
      this.CustInfo = '';
      //this.IsbannerShow=true;
    }
    this.dthInfo();
  }
  checkShowBanner() {
    if (this.DthInfo.length > 0 || this.DthInfo.length > 0) {
      this.IsbannerShow = false;
    }
    else if (this.DthInfo.response.length > 0 || this.DthInfo.response.length > 0) {
      this.IsbannerShow = false;
    }
    else {
      this.IsbannerShow = true;
    }
  }
  onamountClick(amount) {
    this.amount = amount;
    this.RechargeForm.controls['amount'].setValue(amount)
  }

  GetMoreCustDetails() {
    $("#CustMore").toggle();
    if (this.IsCustMore == true) {
      this.IsCustMore = false;
    }
    else if (this.IsCustMore == false) {
      this.IsCustMore = true;
    }
  }


  public displayFn(data?: Select2OptionData): string {
    this.operator = parseInt(data.id);

    return data ? data.text : '';
  }

  Operatorchangednew(event: any): void {
    this.operator = parseInt(event.option.value.id);
    if (this.operator == 0) {
      this.MobileplaceHolder = 'Select DTH Operator';
      return;
    }
    this.spnAmount = '';
    this.spnMobile = '';
    this.odata = this.apiData.getOperatorData(this.operator);
    this.MobileplaceHolder = this.odata.accountName;
    this.AccountRemark = this.odata.accountRemak;
    if (this.odata.isAccountNumeric)
      // Validators.pattern('\\d{10}'),
      this.RechargeForm.controls['mobile'].setValidators([Validators.minLength(this.odata.length), Validators.maxLength(this.odata.lengthMax), Validators.pattern(this.odata.regExAccount)]);
    else
      this.RechargeForm.controls['mobile'].setValidators([Validators.minLength(this.odata.length), Validators.maxLength(this.odata.lengthMax)]);
    this.RechargeForm.controls['amount'].setValidators([Validators.min(this.odata.min), Validators.max(this.odata.max)]);
    // Validators.pattern('^[0-9]+(\.?[0-9]?)')
    this.IsRechargeSubmitted = false;
    this.dthInfo();
  }
  transform(value: string, type?: string): SafeHtml | SafeUrl | SafeResourceUrl {

    return this._sanitizer.bypassSecurityTrustUrl(value);

  }
  inputclear() {
    this.RechargeForm.controls['myControl'].setValue(' ');
  }
  ngOnDestroy(): void {
    // this._ngUnsubscribe$.next('');
    // this._ngUnsubscribe$.unsubscribe();
  }
  updateView() {
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }


  /**
  *
  * Scroller start
  */

  // nav tab scroller scripts starts
  ngAfterViewInit() {
    this.reAdjust();
  }

  @HostListener('window:resize')
  onResize() {
    this.reAdjust();
  }

  setActiveTab(index: number) {
    this.activeIndex = index;
  }

  widthOfList(): number {
    const links = this.tabList.nativeElement.querySelectorAll('li a');
    let width = 0;
    links.forEach(link => {
      width += (link as HTMLElement).offsetWidth;
    });
    return width;
  }

  getLeftPos(): number {
    const listLeft = this.tabList.nativeElement.getBoundingClientRect().left;
    const wrapperLeft = this.wrapperNav.nativeElement.getBoundingClientRect().left;
    return listLeft - wrapperLeft;
  }

  widthOfHidden(): number {
    const wrapperWidth = this.wrapperNav.nativeElement.offsetWidth;
    const hidden = wrapperWidth - this.widthOfList() - this.getLeftPos() - this.scrollBarWidths;
    return hidden;
  }

  scrollRight() {
    const moveAmount = 100; // or any number like 100px
    const list = this.tabList.nativeElement;

    list.style.transition = 'left 0.5s';
    list.style.position = 'relative';

    const currentLeft = parseInt(list.style.left || '0', 10);
    const newLeft = currentLeft - moveAmount;

    this.renderer.setStyle(list, 'left', `${newLeft}px`);
    this.reAdjust();
  }

  scrollLeft() {
    const moveAmount = 100; // move 100px to right
    const list = this.tabList.nativeElement;

    list.style.transition = 'left 0.5s';
    list.style.position = 'relative';

    const currentLeft = parseInt(list.style.left || '0', 10);
    const newLeft = currentLeft + moveAmount;

    this.renderer.setStyle(list, 'left', `${newLeft}px`);
    this.reAdjust();
  }

  reAdjust() {
    if (!this.tabList) {
      return;
    }
    const list = this.tabList.nativeElement;
    const wrapper = this.wrapperNav.nativeElement;

    const rightScroller = wrapper.previousElementSibling as HTMLElement;
    const leftScroller = wrapper.previousElementSibling ? wrapper.previousElementSibling.previousElementSibling as HTMLElement : '';

    const totalListWidth = this.widthOfList();
    const wrapperWidth = wrapper.offsetWidth;
    const listRight = list.getBoundingClientRect().right;
    const wrapperRight = wrapper.getBoundingClientRect().right;

    const currentLeft = parseInt(list.style.left || '0', 10);

    // 👉 Show right scroll button if total list is wider than wrapper
    if (totalListWidth + currentLeft > wrapperWidth) {
      this.renderer.setStyle(rightScroller, 'display', 'flex');
    } else {
      this.renderer.setStyle(rightScroller, 'display', 'none');
    }

    // 👉 Show left scroll button if current left position is less than 0 (meaning some part hidden on left)
    if (currentLeft < 0) {
      this.renderer.setStyle(leftScroller, 'display', 'flex');
    } else {
      this.renderer.setStyle(leftScroller, 'display', 'none');
    }
  }
}
